const updateAriaLabel = () => {
  const element = document.querySelector('.go300628013');
  if (element) {
    element.ariaLabel = "Submit email for newsletter";
  }
};
updateAriaLabel();

const makePreviewImagesDecorative = () => {
    const previewImages = document.querySelectorAll('video > img');
    previewImages.forEach((image) => {
        image.setAttribute('alt', '');
    })
}
makePreviewImagesDecorative();

const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
            updateAriaLabel();
            makePreviewImagesDecorative();
        }
    });
});
observer.observe(document.body, {
  childList: true,
  subtree: true
});